import { atom } from 'recoil'

export const sessionUserGroupState = atom({
  key: 'SessionUserGroup',
  default: undefined,
})
